(function () {
  'use strict';

  if (typeof customElements === 'undefined' || customElements.get('shop-the-look-grid')) {
    return;
  }

  class ShopTheLookGrid extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.getAttribute('data-section-id');
      this.modal = this.querySelector('[data-look-modal]');
      this.panels = this.querySelectorAll('[data-look-panel]');
      this.openButtons = this.querySelectorAll('[data-open-look-modal]');
      this.closeButtons = this.querySelectorAll('[data-close-look-modal]');
      this.moveModalToBody();
      this.bind();
    }

    moveModalToBody() {
      if (!this.modal || !document.body) return;
      document.body.appendChild(this.modal);
    }

    bind() {
      var self = this;

      this.openButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var index = btn.getAttribute('data-block-index');
          self.openModal(index);
        });
      });

      this.closeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.closeModal();
        });
      });

      this.modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          self.closeModal();
        }
      });

      var modal = this.modal;
      if (modal) {
        modal.querySelectorAll('.shop-the-look-grid__quick-add-form').forEach(function (form) {
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.handleQuickAdd(form);
            return false;
          });
        });

        modal.querySelectorAll('[data-variant-select]').forEach(function (select) {
          select.addEventListener('change', function () {
            self.updateAddButtonState(select);
          });
        });
      }
    }

    updateAddButtonState(variantSelect) {
      var form = variantSelect.closest('form');
      if (!form) return;
      var option = variantSelect.options[variantSelect.selectedIndex];
      var available = option && option.getAttribute('data-available') === 'true';
      var btn = form.querySelector('[data-quick-add-btn]');
      if (btn) {
        btn.disabled = !available;
      }
    }

    openModal(blockIndex) {
      if (!this.modal) return;

      this.panels.forEach(function (panel) {
        if (panel.getAttribute('data-block-index') === String(blockIndex)) {
          panel.hidden = false;
        } else {
          panel.hidden = true;
        }
      });

      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';

      var focusTarget = this.modal.querySelector('.shop-the-look-grid__modal-close');
      if (focusTarget) {
        setTimeout(function () {
          focusTarget.focus();
        }, 50);
      }
    }

    closeModal() {
      if (!this.modal) return;

      this.modal.hidden = true;
      document.body.style.overflow = '';
    }

    handleQuickAdd(form) {
      var self = this;
      var submitBtn = form.querySelector('[data-quick-add-btn]');
      var formData = new FormData(form);
      var body = { items: [] };
      var id = formData.get('id');
      var quantity = formData.get('quantity') || 1;

      if (!id) return;

      body.items.push({ id: id, quantity: parseInt(quantity, 10) });
      body.sections = 'cart-drawer';

      if (submitBtn) {
        submitBtn.classList.add('loading');
        submitBtn.setAttribute('disabled', 'disabled');
      }

      var routes = window.routes || {};
      var cartAddUrl = routes.cart_add_url || '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (result.ok) {
            if (window.eventBus && typeof window.eventBus.emit === 'function') {
              window.eventBus.emit('update:cart:drawer', result.data);
              window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
            }
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
              fetch((routes.cart_url || '/cart') + '?view=compare')
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  window.wetheme.updateCartCount(cart);
                })
                .catch(function () {});
            }
          } else if (result.data && result.data.description) {
            if (typeof window.wetheme !== 'undefined' && window.wetheme.showNotification) {
              window.wetheme.showNotification(result.data.description, 'error');
            } else {
              alert(result.data.description);
            }
          }
        })
        .catch(function (err) {
          console.error('Quick add error:', err);
          if (typeof window.wetheme !== 'undefined' && window.wetheme.showNotification) {
            window.wetheme.showNotification('Unable to add to cart', 'error');
          } else {
            alert('Unable to add to cart');
          }
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.classList.remove('loading');
            submitBtn.removeAttribute('disabled');
          }
        });
    }
  }

  customElements.define('shop-the-look-grid', ShopTheLookGrid);
})();
